module.exports = function() {
  return new Worker(__webpack_public_path__ + "23cf49400fea6b867f04.worker.js");
};